// Auto-generated per-query builders for ModelResponse
// DO NOT EDIT - Changes will be overwritten

import { QueryBuilderBase } from '@sourcepilot/framework/query-builder-base';
import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { ModelResponseReadAPI, ModelResponseWriteAPI, ModelResponseReadAPISchema, ModelResponseWriteAPISchema } from '../types/modelresponse';
import { ModelRegistry } from '../../registries/model-registry';
import { AtScope, HasModelRequestResponse, IsPart } from '../../relationships/relationship';

import { ResponsePart } from './responsepart';
import { SecurityScope } from '../../shared/api/securityscope';
import { ModelRequest } from './modelrequest';



// Field names for order_by on ResponsePart
type ResponsePartFields = "created_at" | "-created_at" | "order_index" | "-order_index";



// Builder chain for query: chat-model-response-by-id

export interface ChatModelResponseByIdBuilder_0 {
  get(id: string): ChatModelResponseByIdBuilder_1;
  filter(conditions: { id: string }): ChatModelResponseByIdBuilder_1;
}

export interface ChatModelResponseByIdBuilder_1 {
  all(): Promise<ModelResponse[]>;
  first(): Promise<ModelResponse | null>;
  get(): Promise<ModelResponse[]>;
  execute(): Promise<ModelResponse[]>;
}

// Builder chain for query: chat-model-response-with-parts

export interface ChatModelResponseWithPartsBuilder_0 {
  get(id: string): ChatModelResponseWithPartsBuilder_1;
  filter(conditions: { id: string }): ChatModelResponseWithPartsBuilder_1;
}

export interface ChatModelResponseWithPartsBuilder_1 {
  parts: ChatModelResponseWithPartsBuilder_2;
}

export interface ChatModelResponseWithPartsBuilder_2 {
  orderBy(field?: ResponsePartFields): ChatModelResponseWithPartsBuilder_2;
  all(): Promise<ResponsePart[]>;
  first(): Promise<ResponsePart | null>;
  get(): Promise<ResponsePart[]>;
  execute(): Promise<ResponsePart[]>;
}


// Union of all query entry points
export type ModelResponseQueryBuilder = ChatModelResponseByIdBuilder_0 | ChatModelResponseWithPartsBuilder_0;

// Available query names for .setQuery()
export type ModelResponseQueryNames = "chat-model-response-by-id" | "chat-model-response-with-parts";

// Type narrowing for .setQuery()
export type ModelResponseBuilderForQuery<Q extends ModelResponseQueryNames> =
  Q extends "chat-model-response-by-id" ? ChatModelResponseByIdBuilder_0
  : Q extends "chat-model-response-with-parts" ? ChatModelResponseWithPartsBuilder_0
  : never;

// Type for instance setQuery - returns post-filter/post-get builder
export type ModelResponseInstanceQueryResult<Q extends ModelResponseQueryNames> =
  Q extends "chat-model-response-by-id" ? ChatModelResponseByIdBuilder_1
  : Q extends "chat-model-response-with-parts" ? ChatModelResponseWithPartsBuilder_1
  : never;

// Map path signatures to query names
const QUERY_PATH_MAP: Record<string, string> = {
  '': 'chat-model-response-by-id',
  'parts|order_by': 'chat-model-response-with-parts',
};

// Model-specific QueryBuilder implementation
class QueryBuilderImpl extends QueryBuilderBase {
  constructor(
    modelName: string,
    path: string[] = [],
    params: Record<string, any> = {},
    fetchFn?: (path: string, options?: RequestInit) => Promise<any>,
    queryName?: string,
    scopedParams: Record<string, Record<string, any>> = {}
  ) {
    super(modelName, path, params, fetchFn, queryName, scopedParams, QUERY_PATH_MAP, QueryBuilderImpl);
  }

  setQuery<Q extends ModelResponseQueryNames>(queryName: Q): ModelResponseBuilderForQuery<Q> {
    // Create new builder with queryName set to bypass path lookup
    return new QueryBuilderImpl(
      this.modelName,
      this.path,
      this.params,
      this.fetchFn,
      queryName,
      this.scopedParams
    ) as any;
  }
}

Object.defineProperty(QueryBuilderImpl.prototype, 'parts', {
  get() {
    return new QueryBuilderImpl('ResponsePart', [...this.path, 'parts'], this.params, this.fetchFn, this.queryName, this.scopedParams);
  },
  enumerable: true,
  configurable: true
});

export interface ModelResponse extends Partial<ModelResponseReadAPI> {}
export class ModelResponse extends NeoNodeBase<ModelResponseReadAPI, ModelResponseWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "ModelResponse";
  static readonly readSchema = ModelResponseReadAPISchema;
  static readonly writeSchema = ModelResponseWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
    parts: { target: "ResponsePart", cardinality: "many", isParent: false, relClass: "IsPart", direction: "out" },
    model_request: { target: "ModelRequest", cardinality: "one", isParent: true, relClass: "HasModelRequestResponse", direction: "in" },
  };

  protected get modelName(): string {
    return 'ModelResponse';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return ModelResponse.label;
  }


  constructor(data: Partial<ModelResponseWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: ModelResponseReadAPI, loadContext?: Record<string, any>): ModelResponse {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { model_request, security_scope, parts, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = ModelResponseReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, model_request: model_request, security_scope: security_scope, parts: parts };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return ModelResponse.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadOneRelationship(processed, 'model_request', 'ModelRequest', ModelRegistry);
    loadOneRelationship(processed, 'security_scope', 'SecurityScope', ModelRegistry);
    loadManyRelationship(processed, 'parts', 'ResponsePart', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new ModelResponse(processed as any);

    return instance;
  }

  static filter(conditions: Record<string, any>): ModelResponseQueryBuilder {
    return new QueryBuilderImpl('ModelResponse').filter(conditions) as any;
  }

  static all(): ModelResponseQueryBuilder {
    return new QueryBuilderImpl('ModelResponse') as any;
  }

  static async first(): Promise<ModelResponse | null> {
    const results = await new QueryBuilderImpl('ModelResponse').execute();
    return results[0] || null;
  }


  static setQuery<Q extends ModelResponseQueryNames>(queryName: Q): ModelResponseBuilderForQuery<Q> {
    const builder = new QueryBuilderImpl('ModelResponse');
    return builder.setQuery(queryName);
  }

  /**
   * Instance method to create queries pre-filtered by this instance's ID.
   * Enables queries like: thread.setQuery('thread-with-steps').steps.all()
   * Returns the same builder type as static method after applying ID filter.
   */
  setQuery<Q extends ModelResponseQueryNames>(queryName: Q): ModelResponseInstanceQueryResult<Q> {
    if (!this.id) {
      throw new Error('Cannot query an unsaved instance without an ID');
    }
    // Create a query builder and apply the ID
    const builder = ModelResponse.setQuery(queryName) as any;

    // Try .get(id) first (if the query starts with Thread.get())
    // Otherwise use .filter({id}) (if the query starts with Thread.filter(id=...))
    // The return type mapping handles which builder stage is returned
    if (builder.get && typeof builder.get === 'function') {
      return builder.get(this.id);
    } else if (builder.filter && typeof builder.filter === 'function') {
      return builder.filter({ id: this.id });
    }
    return builder;
  }

  // Relationship manager for 'security_scope' - Python ORM style (cached)
  get security_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('security_scope', () => {
      return new RelationshipManager(this, 'security_scope', 'one', AtScope as typeof Relationship);
    });
  }

  // Relationship manager for 'parts' - Python ORM style (cached)
  get parts(): RelationshipManager<this, ResponsePart> {
    return this.getOrCreateRelationshipManager('parts', () => {
      return new RelationshipManager(this, 'parts', 'many', IsPart as typeof Relationship);
    });
  }

  // Relationship manager for 'model_request' - Python ORM style (cached)
  get model_request(): RelationshipManager<this, ModelRequest> {
    return this.getOrCreateRelationshipManager('model_request', () => {
      return new RelationshipManager(this, 'model_request', 'one', HasModelRequestResponse as typeof Relationship);
    });
  }

}
